// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_uFDCP","box":"index_box_wyIkj","footer":"index_footer_Q9u8w"};